import { useState } from "react";
import { FaArrowRight, FaPlus, FaMinus } from "react-icons/fa";
import { Link } from "react-router-dom";

const praktikblad = "/3.jpg";

const samverkan = [
  {
    title: "Studiebesök",
    text: "Ett förutsättningslöst besök där en ung person får se hur er verksamhet fungerar.",
  },
  {
    title: "Prova en aktivitet",
    text: "Låt en ung person prova något tillsammans med er och upptäcka ett nytt intresse eller sammanhang.",
  },
  {
    title: "Praktik",
    text: "Erbjud en praktikplats där den unga får lära känna verksamheten i sin egen takt.",
  },
];

const faq = [
  {
    question: "Måste vi rapportera tid eller närvaro?",
    answer:
      "Nej, vi har gemensamma uppföljningar.",
  },
  {
    question: "Måste vi kunna erbjuda en praktikplats?",
    answer:
      "Nej. Ni kan också ta emot ett studiebesök, berätta om er verksamhet eller låta en ung person prova en aktivitet.",
  },
  {
    question: "Hur mycket tid behöver vi avsätta?",
    answer:
      "Det beror på vad ni vill och har möjlighet att göra. Vi pratar om omfattningen innan vi bestämmer något tillsammans.",
  },
  {
    question:
      "Vem kontaktar vi om vi har frågor eller om något inte fungerar?",
    answer:
      "Ni får en kontaktperson på Räkna med mig som ni kan höra av er till under samarbetet. Vi är lätta att få kontakt med och vi finns på orten.",
  },
  {
    question: "Kostar det något?",
    answer: "Nej, 🙂",
  },
];

function Eyebrow({ children }) {
  return (
    <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#3BAFA3] sm:text-xs sm:tracking-[0.18em]">
      {children}
    </p>
  );
}

function Section({ children, className = "", id }) {
  return (
    <section
      id={id}
      className={`scroll-mt-20 ${className}`}
    >
      {children}
    </section>
  );
}

function FAQItem({ question, answer, open, onClick }) {
  return (
    <div className="border-t border-neutral-200 last:border-b">
      <button
        type="button"
        onClick={onClick}
        aria-expanded={open}
        className="
          group
          flex
          w-full
          items-center
          justify-between
          gap-4
          py-4
          text-left
          sm:gap-6
          sm:py-5
          md:py-6
        "
      >
        <span
          className="
            min-w-0
            pr-1
            text-sm
            font-semibold
            leading-6
            tracking-[-0.015em]
            text-neutral-900
            sm:text-base
            sm:leading-7
            md:text-lg
          "
        >
          {question}
        </span>

        <span
          className="
            flex
            h-8
            w-8
            shrink-0
            items-center
            justify-center
            rounded-full
            border
            border-neutral-200
            text-[#3BAFA3]
            transition-colors
            duration-300
            group-hover:border-[#3BAFA3]
            sm:h-9
            sm:w-9
          "
        >
          {open ? <FaMinus size={9} /> : <FaPlus size={9} />}
        </span>
      </button>

      {open && (
        <div className="max-w-2xl pb-5 pr-0 sm:pb-7 sm:pr-8">
          <p className="text-sm leading-7 text-neutral-500 sm:text-[15px] sm:leading-8 md:text-[16px]">
            {answer}
          </p>
        </div>
      )}
    </div>
  );
}
function QuestionLink({ number, title, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="
        group
        flex
        w-full
        items-center
        gap-4
        border-t
        border-neutral-200
        py-4
        text-left
        sm:gap-5
        sm:py-5
      "
    >
      <span
        className="
          shrink-0
          text-xs
          font-semibold
          tracking-[0.08em]
          text-[#3BAFA3]
          sm:text-sm
        "
      >
        {number}
      </span>

      <span
        className="
          min-w-0
          flex-1
          text-sm
          font-semibold
          leading-6
          text-neutral-900
          transition-colors
          group-hover:text-[#3BAFA3]
          sm:text-base
          sm:leading-7
        "
      >
        {title}
      </span>

      <FaArrowRight
        size={11}
        className="
          shrink-0
          text-neutral-300
          transition-all
          duration-300
          group-hover:translate-x-1
          group-hover:text-[#3BAFA3]
        "
      />
    </button>
  );
}
function CollaborationCard({ title, text }) {
  return (
    <div className="border-t border-neutral-200 pt-5 sm:pt-6">
      <div className="mb-5 h-1 w-9 rounded-full bg-[#3BAFA3] sm:mb-6 sm:w-10" />

      <h3 className="text-xl font-semibold tracking-[-0.03em] text-neutral-900 sm:text-2xl">
        {title}
      </h3>

      <p className="mt-3 max-w-sm text-sm leading-7 text-neutral-500 sm:text-[15px]">
        {text}
      </p>
    </div>
  );
}

export default function ArbetsgivarePage() {
  const [openFaq, setOpenFaq] = useState(0);
  const handleScrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  return (
    <main className="min-h-screen overflow-x-hidden bg-white text-neutral-900">

      {/* =====================================================
          HEADER
      ===================================================== */}

      <header className="relative z-30 bg-white">
        <div
          className="
            mx-auto
            flex
            max-w-6xl
            items-center
            justify-between
            gap-3
            px-4
            py-3
            sm:px-6
            sm:py-4
            md:px-10
            md:py-5
            lg:px-16
          "
        >
         {/* LOGO */}
{/* LOGO */}
<Link
  to="/"
  className="group flex min-w-0 shrink items-center"
  aria-label="Räkna med mig – startsida"
>
  <img
    src="/icon.png"
    alt="Räkna med mig"
    className="
      h-[120px]
      md:h-[150px]
      w-auto
      max-w-full
      object-contain
      transition-transform
      duration-300
      group-hover:scale-[1.03]
    "
  />
</Link>

          {/* KONTAKT */}
          <a
            href="#kontakt"
            className="
              group
              inline-flex
              shrink-0
              items-center
              justify-center
              gap-2
              rounded-full
              bg-[#3BAFA3]
              px-3.5
              py-2
              text-xs
              font-semibold
              text-white
              shadow-[0_5px_18px_rgba(59,175,163,0.14)]
              transition-all
              duration-300
              hover:-translate-y-0.5
              hover:bg-[#31988e]
              hover:shadow-[0_10px_28px_rgba(59,175,163,0.20)]
              sm:gap-2.5
              sm:px-5
              sm:py-2.5
              sm:text-sm
              md:px-6
              md:py-3
            "
          >
            Kontakta oss

            <FaArrowRight
              size={10}
              className="transition-transform duration-300 group-hover:translate-x-1 sm:size-[12px]"
            />
          </a>
        </div>
      </header>

      {/* =====================================================
          HERO
      ===================================================== */}

      <Section className="overflow-hidden bg-white">
        <div
          className="
            mx-auto
            max-w-6xl
            px-4
            pb-14
            pt-10
            sm:px-6
            sm:pb-20
            sm:pt-14
            md:px-10
            md:pb-24
            md:pt-20
            lg:px-16
            lg:pb-28
          "
        >
          <div
            className="
              grid
              gap-10
              xl:grid-cols-[1.05fr_0.95fr]
              xl:items-end
              xl:gap-24
            "
          >
            <div className="min-w-0">
              <Eyebrow>För företag & föreningar</Eyebrow>

             <h1
  className="
    mt-5
    max-w-3xl
    text-[38px]
    font-semibold
    leading-[0.98]
    tracking-[-0.055em]
    text-neutral-900
    sm:mt-6
    sm:text-[46px]
    md:text-[58px]
    lg:text-[68px]
    xl:text-[76px]
  "
>
  Ni kan vara en del av{" "}
  <span className="text-[#3BAFA3]">
    nästa steg.
  </span>
</h1>
            </div>

            <div className="max-w-xl xl:pb-1">
              <p className="text-base leading-7 text-neutral-700 sm:text-lg sm:leading-8 md:text-xl md:leading-9">
                Driver du ett företag eller är du engagerad i en förening?
              </p>

              <p className="mt-4 text-[15px] leading-7 text-neutral-500 sm:mt-5 sm:text-[16px] sm:leading-8 md:text-[17px]">
                Genom att samarbeta med Räkna med mig kan du ge en ung person
                möjligheter att upptäcka ett intresse, prova en aktivitet eller
                lära känna en arbetsplats. En möjlighet som gör stor skillnad.
              </p>

              <p className="mt-4 text-[15px] leading-7 text-neutral-500 sm:mt-5 sm:text-[16px] sm:leading-8 md:text-[17px]">
                Ett samarbete kan börja med ett studiebesök, några träffar i
                er verksamhet eller en praktikplats. Ni behöver inte ha ett
                färdigt upplägg – hör av er, så pratar vi om vad som skulle
                kunna fungera för er och för den unga.
              </p>
            </div>
          </div>
        </div>
      </Section>

     {/* =====================================================
    INTRO STRIP
===================================================== */}

<section className="border-y border-white/10 bg-black text-white">
  <div
    className="
      mx-auto
      max-w-6xl
      px-4
      py-8
      sm:px-6
      sm:py-10
      md:px-10
      md:py-12
      lg:px-16
    "
  >
    <div
      className="
        flex
        flex-col
        gap-6
        sm:gap-8
        md:flex-row
        md:items-center
        md:justify-between
      "
    >
      <div className="flex min-w-0 items-center gap-4 sm:gap-5">
        <div className="h-11 w-1 shrink-0 rounded-full bg-[#3BAFA3] sm:h-12" />

        <p
          className="
            text-lg
            font-semibold
            leading-7
            tracking-[-0.02em]
            text-white
            sm:text-xl
            md:text-2xl
          "
        >
          Ett samarbete behöver inte börja stort.
        </p>
      </div>

      <a
        href="#samverka"
        className="
          group
          inline-flex
          shrink-0
          items-center
          gap-2.5
          self-start
          text-base
          font-semibold
          text-[#3BAFA3]
          transition-colors
          duration-300
          hover:text-[#5bc4b8]
          sm:gap-3
          sm:text-lg
          md:self-auto
          md:text-xl
        "
      >
        Se hur ni kan bidra

        <FaArrowRight
          size={12}
          className="transition-transform duration-300 group-hover:translate-x-1.5"
        />
      </a>
    </div>
  </div>
</section>
{/* =====================================================
    QUESTION NAVIGATION
===================================================== */}

<section className="border-y border-black/5 bg-[#F8FAFA]">
  <div
    className="
      mx-auto
      max-w-6xl
      px-5
      py-10
      sm:px-6
      sm:py-12
      md:px-10
      md:py-16
      lg:px-16
    "
  >
    <div
      className="
        grid
        gap-8
        md:gap-10
        lg:grid-cols-[0.55fr_1fr]
        lg:gap-20
      "
    >
      {/* TEXT */}

      <div>
        <Eyebrow>
          Vad vill ni veta?
        </Eyebrow>

        <h2
          className="
            mt-5
            text-3xl
            font-semibold
            leading-[1.05]
            tracking-[-0.04em]
            text-neutral-900
            sm:text-4xl
          "
        >
          Börja där det känns rätt för er.
        </h2>

        <p
          className="
            mt-4
            max-w-md
            text-[15px]
            leading-7
            text-neutral-600
          "
        >
          Ni behöver inte läsa allt. Välj en fråga och läs mer om
          just det ni funderar på.
        </p>
      </div>

      {/* FRÅGOR */}

      <div>

       <QuestionLink
  number="01"
  title="Hur kan vi samverka?"
  onClick={() => handleScrollTo("samverka")}
/>

<QuestionLink
  number="02"
  title="Hur fungerar praktik?"
  onClick={() => handleScrollTo("praktik")}
/>

<QuestionLink
  number="03"
  title="Hur går ett samarbete till?"
  onClick={() => handleScrollTo("samarbetet")}
/>

<QuestionLink
  number="04"
  title="Vad kan vi som arbetsgivare bidra med?"
  onClick={() => handleScrollTo("arbetsgivares-perspektiv")}
/>

<QuestionLink
  number="05"
  title="Vanliga frågor"
  onClick={() => handleScrollTo("vanliga-fragor")}
/>

<QuestionLink
  number="06"
  title="Kontakta oss"
  onClick={() => handleScrollTo("kontakt")}
/>

      </div>
    </div>
  </div>
</section>
      {/* =====================================================
          SAMVERKAN
      ===================================================== */}

      <Section id="samverka" className="bg-white">
        <div
          className="
            mx-auto
            max-w-6xl
            px-4
            py-16
            sm:px-6
            sm:py-20
            md:px-10
            md:py-24
            lg:px-16
            xl:py-28
          "
        >
          <div
            className="
              grid
              gap-10
              xl:grid-cols-[0.8fr_1.2fr]
              xl:gap-24
            "
          >
            <div className="min-w-0">
              <Eyebrow>Så kan ni samverka med oss</Eyebrow>

              <h2
                className="
                  mt-5
                  text-[32px]
                  font-semibold
                  leading-[1.05]
                  tracking-[-0.045em]
                  text-neutral-900
                  sm:text-4xl
                  md:text-5xl
                "
              >
                Tillsammans värnar vi om framtidens
                <br className="hidden sm:block" />
                {" "}kompetens.
              </h2>

              <p className="mt-6 max-w-md text-[15px] leading-7 text-neutral-500 sm:mt-7 sm:text-[16px] sm:leading-8">
                Ni kan bidra på olika sätt, utifrån vad som fungerar i er
                verksamhet. Det viktiga är inte att ha ett färdigt upplägg,
                utan att hitta något som fungerar tillsammans.
              </p>
            </div>

            <div className="grid gap-x-8 gap-y-10 sm:grid-cols-2 sm:gap-x-10 sm:gap-y-12">
              {samverkan.map((item) => (
                <CollaborationCard
                  key={item.title}
                  title={item.title}
                  text={item.text}
                />
              ))}
            </div>
          </div>

          <div className="mt-10 border-t border-neutral-200 pt-6 sm:mt-14 sm:pt-7">
            <p className="max-w-3xl text-[15px] leading-7 text-neutral-500 sm:text-[16px] sm:leading-8">
              Vi behöver inte bestämma i förväg exakt hur samarbetet ska se ut.
              Tillsammans kommer vi överens om vad som passar er och den unge.
            </p>
          </div>
        </div>
      </Section>

      {/* =====================================================
          PRAKTIK
      ===================================================== */}

    <Section id="praktik" className="bg-[#E8F7F5]">
        <div
          className="
            mx-auto
            max-w-6xl
            px-4
            py-14
            sm:px-6
            sm:py-20
            md:px-10
            md:py-24
            lg:px-16
          "
        >
          <div
            className="
              grid
              gap-8
              lg:grid-cols-1
              xl:grid-cols-[1fr_auto]
              xl:items-center
              xl:gap-12
            "
          >
            <div className="min-w-0">
              <Eyebrow>Praktik</Eyebrow>

              <h2
                className="
                  mt-4
                  max-w-2xl
                  text-[28px]
                  font-semibold
                  leading-[1.08]
                  tracking-[-0.04em]
                  text-neutral-900
                  sm:mt-5
                  sm:text-3xl
                  md:text-4xl
                "
              >
                Hos oss är det enkelt att ta emot en ung person på praktik.
              </h2>

              <p className="mt-4 max-w-2xl text-[15px] leading-7 text-neutral-600 sm:mt-5 sm:text-[16px] sm:leading-8">
                Läs mer i vårt infoblad om praktik.
              </p>
            </div>

            <a
              href={praktikblad}
              target="_blank"
              rel="noreferrer"
              className="
                group
                inline-flex
                w-full
                items-center
                justify-center
                gap-3
                rounded-full
                bg-neutral-950
                px-6
                py-3.5
                text-sm
                font-semibold
                text-white
                shadow-[0_10px_30px_rgba(0,0,0,0.08)]
                transition-all
                duration-300
                hover:-translate-y-0.5
                hover:bg-neutral-800
                hover:shadow-[0_15px_40px_rgba(0,0,0,0.12)]
                sm:w-auto
                sm:px-7
                sm:py-4
                xl:shrink-0
              "
            >
              Öppna infobladet

              <FaArrowRight
                size={11}
                className="text-[#3BAFA3] transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
          </div>
        </div>
      </Section>

      {/* =====================================================
          HOW IT WORKS
      ===================================================== */}

     <Section id="samarbetet" className="bg-neutral-950 text-white">
        <div
          className="
            mx-auto
            max-w-6xl
            px-4
            py-16
            sm:px-6
            sm:py-20
            md:px-10
            md:py-24
            lg:px-16
            xl:py-28
          "
        >
          <div
            className="
              grid
              gap-10
              xl:grid-cols-[0.8fr_1.2fr]
              xl:gap-24
            "
          >
            <div>
              <Eyebrow>Så fungerar samarbetet</Eyebrow>

              <h2
                className="
                  mt-5
                  text-[32px]
                  font-semibold
                  leading-[1.05]
                  tracking-[-0.045em]
                  sm:text-4xl
                  md:text-5xl
                "
              >
                Vi planerar
                <br />
                tillsammans.
              </h2>
            </div>

            <div className="max-w-2xl">
              <div className="border-t border-white/15">

                {/* 01 */}
                <div className="grid gap-3 border-b border-white/15 py-6 sm:gap-5 sm:py-7 md:grid-cols-[64px_1fr] md:gap-6 lg:grid-cols-[80px_1fr]">
                  <span className="text-sm font-semibold text-[#3BAFA3] sm:text-base">
                    01
                  </span>

                  <div>
                    <h3 className="text-xl font-semibold tracking-[-0.025em] sm:text-2xl sm:tracking-[-0.03em]">
                      Vi börjar med ett samtal
                    </h3>

                    <p className="mt-3 text-[15px] leading-7 text-white/60 sm:text-[16px] sm:leading-8">
                      Vi pratar om vad som skulle fungera i er verksamhet och
                      vad den unga är intresserad av.
                    </p>
                  </div>
                </div>

                {/* 02 */}
                <div className="grid gap-3 border-b border-white/15 py-6 sm:gap-5 sm:py-7 md:grid-cols-[64px_1fr] md:gap-6 lg:grid-cols-[80px_1fr]">
                  <span className="text-sm font-semibold text-[#3BAFA3] sm:text-base">
                    02
                  </span>

                  <div>
                    <h3 className="text-xl font-semibold tracking-[-0.025em] sm:text-2xl sm:tracking-[-0.03em]">
                      Vi planerar upplägget
                    </h3>

                    <p className="mt-3 text-[15px] leading-7 text-white/60 sm:text-[16px] sm:leading-8">
                      Om ni vill gå vidare planerar vi tillsammans vad den
                      unga ska få prova, i vilken omfattning, när det ska ske
                      och vem som tar emot på plats.
                    </p>
                  </div>
                </div>

                {/* 03 */}
                <div className="grid gap-3 border-b border-white/15 py-6 sm:gap-5 sm:py-7 md:grid-cols-[64px_1fr] md:gap-6 lg:grid-cols-[80px_1fr]">
                  <span className="text-sm font-semibold text-[#3BAFA3] sm:text-base">
                    03
                  </span>

                  <div>
                    <h3 className="text-xl font-semibold tracking-[-0.025em] sm:text-2xl sm:tracking-[-0.03em]">
                      Vi finns med under vägen
                    </h3>

                    <p className="mt-3 text-[15px] leading-7 text-white/60 sm:text-[16px] sm:leading-8">
                      En medarbetare från Räkna med mig finns som kontaktperson
                      under samarbetet. Vi följer upp hur det fungerar för både
                      er och den unga och ändrar upplägget vid behov.
                    </p>
                  </div>
                </div>
              </div>

              {/* CONTACT HIGHLIGHT */}
              <div className="mt-6 rounded-[20px] border border-[#3BAFA3]/30 bg-[#3BAFA3]/10 p-5 sm:mt-8 sm:rounded-[24px] sm:p-7 md:p-8">
                <div className="flex gap-4 sm:gap-5">
                  <div className="mt-1 h-9 w-1 shrink-0 rounded-full bg-[#3BAFA3] sm:h-10" />

                  <div className="min-w-0">
                    <p className="text-base font-semibold text-white sm:text-lg">
                      Ni står inte ensamma i samarbetet.
                    </p>

                    <p className="mt-2 max-w-xl text-sm leading-7 text-white/65 sm:text-[15px] md:text-base">
                      Ni har alltid en kontaktperson från Räkna med mig att
                      vända er till om frågor uppstår eller om något behöver
                      förändras längs vägen.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* =====================================================
          EMPLOYER STORY
      ===================================================== */}

  <Section
  id="arbetsgivares-perspektiv"
  className="bg-white"
>
        <div
          className="
            mx-auto
            max-w-6xl
            px-4
            py-16
            sm:px-6
            sm:py-20
            md:px-10
            md:py-24
            lg:px-16
            xl:py-28
          "
        >
          <div
            className="
              grid
              gap-10
              xl:grid-cols-[0.75fr_1.25fr]
              xl:gap-24
            "
          >

            {/* INTRO */}
            <div className="min-w-0">
              <Eyebrow>En arbetsgivares perspektiv</Eyebrow>

              <h2
                className="
                  mt-5
                  text-[32px]
                  font-semibold
                  leading-[1.05]
                  tracking-[-0.045em]
                  text-neutral-900
                  sm:text-4xl
                  md:text-5xl
                "
              >
                Att bidra lokalt är en del av vårt ansvar.
              </h2>

              {/* PERSON */}
              <div className="mt-7 flex items-center gap-4 sm:mt-8">
                <img
                  src="/lennart.png"
                  alt="Lennart Sundh"
                  className="h-14 w-14 shrink-0 rounded-full object-cover shadow-sm sm:h-16 sm:w-16"
                />

                <div className="min-w-0">
                  <p className="font-semibold text-neutral-900">
                    Lennart Sundh
                  </p>

                  <p className="text-sm text-neutral-500">
                    VD, Xlent Hudiksvall
                  </p>
                </div>
              </div>

              {/* STATEMENT */}
              <div className="mt-12 border-t border-black/10 pt-5 sm:mt-16 sm:pt-6">
                <p className="text-[11px] font-semibold uppercase tracking-[0.13em] text-[#3BAFA3] sm:text-xs sm:tracking-[0.14em]">
                  Socialt ansvar i praktiken
                </p>

                <p className="mt-4 max-w-sm text-base font-medium leading-7 text-neutral-700 sm:text-lg">
                  När många väljer att bidra med små aktiva insatser skapas
                  tillsammans en stor positiv påverkan på samhället.
                </p>
              </div>
            </div>

            {/* STORY */}
            <div className="min-w-0 max-w-2xl">

              {/* LOGO / BILD */}
              <div className="mb-8 flex h-24 items-center justify-center rounded-[22px] p-5 sm:mb-10 sm:h-32 sm:rounded-[28px] sm:p-8">
                <img
                  src="/xlent.png"
                  alt="Xlent"
                  className="max-h-12 max-w-full w-auto object-contain sm:max-h-14"
                />
              </div>

              {/* INTRO */}
              <p className="text-base leading-7 text-neutral-700 sm:text-lg sm:leading-8">
                Som lokalt konsultbolag i Hudiksvall ser vi socialt ansvar som
                en självklar del av vårt företag. Att vara en aktiv och positiv
                kraft i det samhälle där vi verkar handlar om mer än affärer.
              </p>

              {/* QUOTE */}
              <blockquote className="my-8 border-l-2 border-[#3BAFA3] pl-4 sm:my-10 sm:pl-6">
                <p
                  className="
                    text-xl
                    font-semibold
                    leading-snug
                    tracking-[-0.02em]
                    text-neutral-900
                    sm:text-2xl
                    md:text-3xl
                  "
                >
                  ”Vi vill bidra till människors utveckling, skapa möjligheter
                  för nästa generation i arbetslivet och vara med och bygga ett
                  starkare och mer hållbart lokalsamhälle.”
                </p>
              </blockquote>

              {/* TEXT */}
              <div className="space-y-5 text-sm leading-7 text-neutral-600 sm:space-y-6">
                <p>
                  Därför engagerar vi oss i utbildning, föreningsliv,
                  näringslivsutveckling och initiativ som uppmuntrar
                  inkludering, kompetensutveckling och social hållbarhet.
                </p>

                <p>
                  För oss är socialt ansvar också en investering i långsiktig
                  framgång. Företag som tar ansvar för människor och samhälle
                  bygger starkare relationer, större förtroende och en mer
                  attraktiv kultur för både medarbetare och kunder.
                </p>

                <p>
                  När medarbetare känner delaktighet, engagemang och mening
                  skapas bättre förutsättningar för innovation, samarbete och
                  hållbar tillväxt.
                </p>
              </div>

              {/* HIGHLIGHT */}
              <div className="mt-8 rounded-[20px] bg-[#f5f3ef] p-5 sm:mt-10 sm:rounded-[24px] sm:p-7 md:p-8">
                <p className="text-base font-semibold leading-relaxed text-neutral-900 sm:text-lg">
                  ”Det handlar inte om stora projekt eller omfattande
                  satsningar. Ofta är det de små, konkreta handlingarna som kan
                  göra stor skillnad.”
                </p>

                <p className="mt-4 text-sm leading-7 text-neutral-600">
                  Att vara mentor, öppna dörrar för unga talanger, stötta
                  lokala initiativ eller uppmärksamma människor som gör gott i
                  sin vardag kan få långt större betydelse än man först tror.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* =====================================================
          FAQ
      ===================================================== */}

     <Section
  id="vanliga-fragor"
  className="bg-[#F8FAFA]"
>
        <div
          className="
            mx-auto
            max-w-3xl
            px-4
            py-16
            sm:px-6
            sm:py-20
            md:px-10
            md:py-24
          "
        >
          <div className="mb-8 sm:mb-10">
            <Eyebrow>Vanliga frågor</Eyebrow>

            <h2
              className="
                mt-4
                text-[32px]
                font-semibold
                leading-[1.05]
                tracking-[-0.045em]
                text-neutral-900
                sm:mt-5
                sm:text-4xl
                md:text-5xl
              "
            >
              Det viktigaste, samlat.
            </h2>
          </div>

          <div>
            {faq.map((item, index) => (
              <FAQItem
                key={item.question}
                question={item.question}
                answer={item.answer}
                open={openFaq === index}
                onClick={() =>
                  setOpenFaq(openFaq === index ? -1 : index)
                }
              />
            ))}
          </div>
        </div>
      </Section>


{/* =====================================================
    CONTACT
===================================================== */}

<section
  id="kontakt"
  className="scroll-mt-20 overflow-hidden bg-[#E8F7F5]"
>
  <div
    className="
      mx-auto
      max-w-6xl
      px-4
      py-12
      sm:px-6
      sm:py-16
      md:px-10
      md:py-20
      lg:px-16
      xl:py-20
    "
  >
    <div
      className="
        grid
        gap-8
        xl:grid-cols-[0.8fr_1.2fr]
        xl:items-center
        xl:gap-16
      "
    >
      {/* =====================================================
          TEXT
      ===================================================== */}

      <div className="min-w-0">
        <Eyebrow>Kontakta oss</Eyebrow>

        <h2
          className="
            mt-4
            max-w-3xl
            text-[38px]
            font-semibold
            leading-[0.98]
            tracking-[-0.055em]
            text-neutral-900
            sm:text-5xl
            md:text-6xl
          "
        >
          Har ni en idé?
        </h2>

        <p
          className="
            mt-5
            max-w-xl
            text-base
            leading-7
            text-neutral-600
            sm:mt-6
            sm:text-lg
            sm:leading-8
          "
        >
          Vill ni veta mer om möjligheterna att samarbeta? Kontakta
          Fredrik, oavsett om er verksamhet finns i Hudiksvall, Ljusdal
          eller Nordanstig.
        </p>
      </div>

      {/* =====================================================
          CONTACT CARD
      ===================================================== */}

      <div
        className="
          group
          min-w-0
          overflow-hidden
          rounded-[18px]
          bg-white
          shadow-[0_14px_40px_rgba(0,0,0,0.055)]
          ring-1
          ring-black/[0.04]

          sm:rounded-[26px]
        "
      >
        <div
          className="
            grid
            grid-cols-[0.9fr_1.1fr]
          "
        >
    
{/* =====================================================
    BILD
===================================================== */}

<div
  className="
    relative
    h-full
    min-h-[115px]
    sm:min-h-[210px]
    md:min-h-[225px]
    bg-[#EAF5F3]
  "
>
  <img
    src="/Fredrik.jpg"
    alt="Fredrik Nygren"
    className="
      absolute
      inset-0
      h-full
      w-full
      object-cover
      object-[center_30%]
      transition-transform
      duration-700
      group-hover:scale-[1.02]
    "
  />

  <div
    className="
      pointer-events-none
      absolute
      inset-x-0
      bottom-0
      h-12
      bg-gradient-to-t
      from-black/20
      to-transparent
      sm:h-16
    "
  />
</div>


          {/* =====================================================
              INNEHÅLL
          ===================================================== */}

          <div
            className="
              flex
              min-w-0
              flex-col
              justify-center
              p-3

              sm:p-6

              md:p-7
            "
          >
            <p
              className="
                text-[8px]
                font-semibold
                uppercase
                tracking-[0.16em]
                text-[#3BAFA3]

                sm:text-[11px]
              "
            >
              Metodstödjare
            </p>

            <h3
              className="
                mt-1
                text-base
                font-semibold
                tracking-[-0.03em]
                text-neutral-900

                sm:mt-2
                sm:text-2xl
              "
            >
              Fredrik Nygren
            </h3>

            <p
              className="
                mt-0.5
                text-[10px]
                text-neutral-500

                sm:text-sm
              "
            >
              Hudiksvalls kommun
            </p>

            <div
              className="
                my-2.5
                h-px
                bg-neutral-100

                sm:my-5
              "
            />

            <div
              className="
                space-y-1
                text-[9px]
                leading-4
                text-neutral-600

                sm:space-y-1.5
                sm:text-sm
                sm:leading-6
              "
            >
              <a
                href="mailto:fredrik.nygren@hudiksvall.se"
                className="
                  block
                  break-words
                  transition-colors
                  hover:text-[#3BAFA3]
                "
              >
                fredrik.nygren@hudiksvall.se
              </a>

              <a
                href="tel:070-1904386"
                className="
                  block
                  transition-colors
                  hover:text-[#3BAFA3]
                "
              >
                070-1904386
              </a>

              <p>
                Hudiksvall · Ljusdal · Nordanstig
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* =====================================================
          FOOTER
      ===================================================== */}

      <footer className="border-t border-neutral-200 bg-white">
        <div
          className="
            mx-auto
            flex
            max-w-6xl
            flex-col
            gap-2
            px-4
            py-6
            text-center
            text-xs
            text-neutral-400
            sm:gap-4
            sm:px-6
            sm:py-7
            sm:text-sm
            md:flex-row
            md:items-center
            md:justify-between
            md:px-10
            md:text-left
            lg:px-16
          "
        >
          <p>© Räkna med mig</p>

          <p>
            Hudiksvall · Ljusdal · Nordanstig
          </p>
        </div>
      </footer>

    </main>
  );
}